import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
import { Button } from './ui/Button';
export const SolutionReveal = () => {
  return <section className="w-full bg-[#1B2A4A] text-white py-20 px-4 md:py-28 relative overflow-hidden" data-id="element-155">
      {/* Background decoration */}
      <div className="absolute top-0 right-0 w-64 h-64 bg-[#2ABFBF]/10 rounded-full blur-3xl transform translate-x-1/2 -translate-y-1/2" data-id="element-156" />
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-[#E8734A]/10 rounded-full blur-3xl transform -translate-x-1/2 translate-y-1/2" data-id="element-157" />

      <div className="max-w-5xl mx-auto relative z-10" data-id="element-158">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center" data-id="element-159">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} data-id="element-160">
            <span className="text-[#2ABFBF] font-bold tracking-wider uppercase text-sm mb-2 block" data-id="element-161">
              Presentando
            </span>
            <h2 className="text-4xl md:text-5xl font-serif font-bold mb-6 text-white" data-id="element-162">
              La Ruta Clara <br data-id="element-163" />
              <span className="text-2xl md:text-3xl font-normal opacity-80" data-id="element-164">
                (18–24 meses)
              </span>
            </h2>
            <p className="text-lg text-white/90 leading-relaxed mb-8" data-id="element-165">
              Una guía práctica para padres que te lleva de{' '}
              <span className="italic" data-id="element-166">
                “No sé si esto es normal o una señal…”
              </span>{' '}
              a{' '}
              <span className="font-bold text-[#2ABFBF]" data-id="element-167">
                “Tengo un plan. Sé qué observar. Sé qué registrar. Sé qué
                pedir.”
              </span>
            </p>

            <Button variant="primary" size="lg" className="w-full md:w-auto bg-[#2ABFBF] text-white hover:bg-[#25a9a9]" data-id="element-168">
              Descargar ahora — $19
            </Button>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-white/5 backdrop-blur-sm border border-white/10 p-8 rounded-2xl" data-id="element-169">
            <h3 className="text-xl font-bold mb-6 text-[#FFF9F3]" data-id="element-170">
              En 30–45 minutos vas a:
            </h3>
            <ul className="space-y-4" data-id="element-171">
              {['Entender qué señales importan en contexto (sin listas infinitas)', 'Diferenciar 18 vs 24 meses para tomar mejores decisiones', 'Usar un tracker de 7 días que te da evidencia simple', 'Seguir un plan de 14 días con pasos concretos', 'Usar guiones listos para pediatra, daycare y familia'].map((item, idx) => <li key={idx} className="flex items-start space-x-3" data-id="element-172">
                  <div className="mt-1 bg-[#2ABFBF] rounded-full p-0.5" data-id="element-173">
                    <Check className="w-3 h-3 text-[#1B2A4A]" data-id="element-174" />
                  </div>
                  <span className="text-white/90" data-id="element-175">{item}</span>
                </li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
};